export const MCP_TUTORIAL_LINK = 'https://kotae.ai/tutorials/activepieces-mcp-to-kotae'
export const PUBLISH_TUTORIAL_LINK = 'https://kotae.ai/tutorials/embed-kotae-tutorial'
export const MOBILE_SETUP_TUTORIAL_LINK = 'https://kotae.ai/help/article/kotae-mobile-setup'